import { NotifyHelper } from "../../../helpers/toast";
import { objFormRegisterResultDefine } from "../../action-types/form/IFormRegisterResultActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const formRegisterResultActions = {
    ...generateActions(objFormRegisterResultDefine, "FORM_REGISTER_RESULT"),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "LOAD_COSO_CHIENDICH_SUCCESS", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "LOAD_COSO_CHIENDICH_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_INVITE_SUCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_INVITE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_RESULT_SUCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_RESULT_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_HOCSINH_SUCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_HOCSINH_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_STATUS_SUCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "UPDATE_STATUS_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "SAVE_ATTENDANCE_SUCESS", (m: any) => NotifyHelper.Success("Updated")),
    ...generateActionForKey(objFormRegisterResultDefine, "FORM_REGISTER_RESULT",
        "SAVE_ATTENDANCE_ERROR", (m: any) => NotifyHelper.Error(m)),
}
